export default __webpack_public_path__ + "static/media/c1286858b15f83ce.60e42a91313de14479d6e760088c7681.svg";